import Nullstack from 'nullstack';
export default function IconAd2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ad-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11.933 5h-6.933v16h13v-8"
  }), "   ", Nullstack.element("path", {
    d: "M14 17h-5"
  }), "   ", Nullstack.element("path", {
    d: "M9 13h5v-4h-5z"
  }), "   ", Nullstack.element("path", {
    d: "M15 5v-2"
  }), "   ", Nullstack.element("path", {
    d: "M18 6l2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M19 9h2"
  }), " ");
}